<template>
  <div class="view-it-smi">
    <div class="view-it-smi__content">
      <h3 class="view-it-smi__title">СМИ о нас</h3>
      <div class="view-it-smi__desc">
        О наших сервисах и решениях регулярно публикуют статьи крупнейшие
        отраслевые СМИ и новостные порталы
      </div>
    </div>

    <ul class="view-it-smi__list">
      <li v-for="item in smi" :key="item.link">
        <div class="view-it-smi__item">
          <img :src="item.logo" class="view-it-smi__item-logo" alt="" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ViewItSmi',
  components: {},
  props: {},
  data() {
    return {
      smi: [
        {
          link:
            'https://www.forbes.ru/partner-article/440257-ojl-resurs-grupp-novyj-uroven-kupli-prodazi-nefteproduktov',
          logo: `${process.env.BASE_URL}static/smi/1.png`,
        },
        {
          link:
            'https://plus.rbc.ru/news/62172fca7a8aa91bbbe9e09c?utm_source=rbc&utm_medium=main&utm_campaign=850542-851602-62172fca7a8aa91bbbe9e09c&from=column_27',
          logo: `${process.env.BASE_URL}static/smi/2.png`,
        },
        {
          link: 'https://vc.ru/oilresurs',
          logo: `${process.env.BASE_URL}static/smi/3.png`,
        },
        {
          link: 'https://www.banki.ru/news/lenta/?id=10961051',
          logo: `${process.env.BASE_URL}static/smi/4.png`,
        },
        {
          link:
            'https://zen.ati.su/news/2022/01/24/kak-ne-stat-zhertvoj-moshennikov-pri-pokupke-topliva-optom-979792/',
          logo: `${process.env.BASE_URL}static/smi/5.png`,
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.view-it-smi {
  display: flex;
  align-items: center;
  padding: 40px 60px;
  color: #fff;
  background-image: linear-gradient(339.34deg, #02b55f 31.27%, #2bca6d 77.23%);
  border-radius: 4px;

  @include media-md() {
    flex-wrap: wrap;
    padding: 40px 20px;
    text-align: center;
  }

  &__content {
    width: 430px;
    max-width: 30%;
    padding-right: 40px;

    @include media-md() {
      width: 100%;
      max-width: initial;
      padding-right: 0;
    }
  }

  &__title {
    margin: 0 0 30px;
    font-size: 36px;
    font-weight: 700;
    line-height: 1.2;

    @include media-md() {
      margin-bottom: 15px;
      font-size: 22px;
    }
  }

  &__desc {
    font-size: 15px;
    font-weight: 300;
    line-height: 1.3;

    @include media-md() {
      margin-bottom: 15px;
      font-size: 13px;
    }
  }

  &__item {
    display: block;
    opacity: 0.5;
    transition: all 0.2s linear;

    &:hover {
      opacity: 1;
    }
  }

  &__list {
    position: relative;
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: space-between;
    padding: 0;
    list-style: none;

    li {
      margin: 5px 10px;
    }

    @include media-lg() {
      flex-wrap: wrap;
      justify-content: center;
    }

    &::before {
      width: 3px;
      height: 130px;
      margin-right: 30px;
      content: '';
      background: #fff;

      @include media-md() {
        display: none;
      }
    }
  }
}
</style>
